const Cart = () => {
  return <h1 style={{ margin: '250px 0', textAlign: 'center' }}>Soon...</h1>;
};

export default Cart;
